import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome';
import Alpine from 'alpinejs';
import axios from 'axios';
import { Dropdown, Modal, Popover, Toast, Tooltip } from 'bootstrap';
import { createApp, defineAsyncComponent } from 'vue';
import CookieJar from './src/cookie-jar';
const app = createApp({
    name: 'VOD'
});
app.config.compilerOptions.whitespace = 'preserve';
app.component('font-awesome-icon', FontAwesomeIcon);
app.component('height-input', defineAsyncComponent(() => import('./components/HeightInput.vue')));
app.component('publish-switch', defineAsyncComponent(() => import('./components/PublishSwitch.vue')));
app.component('share-link', defineAsyncComponent(() => import('./components/ShareLink.vue')));
app.component('video-chapter-manager', defineAsyncComponent(() => import('./components/VideoChapterManager.vue')));
app.component('video-player', defineAsyncComponent(() => import('./components/VideoPlayer.vue')));
app.component('video-uploader', defineAsyncComponent(() => import('./components/VideoUploader.vue')));
app.component('weight-input', defineAsyncComponent(() => import('./components/WeightInput.vue')));
app.component('wrestlers-input', defineAsyncComponent(() => import('./components/WrestlersInput.vue')));
app.mount('#app');
window.Alpine = Alpine;
window.axios = axios;
window.axios.defaults.headers.common['X-Requested-With'] = 'XMLHttpRequest';
window.bootstrap = window.bootstrap || {};
window.bootstrap.Dropdown = Dropdown;
window.bootstrap.Modal = Modal;
window.bootstrap.Popover = Popover;
window.CookieJar = new CookieJar(document);
document.querySelectorAll('[data-bs-toggle="tooltip"]').forEach((element) => new Tooltip(element));
document.querySelectorAll('.toast').forEach((element) => new Toast(element).show());
Alpine.start();
